import React, { useState } from "react";
import { register } from "../store/auth/AuthActions.js";
import logoUrl from "img/zeta-logo.png";
import { useDispatch } from "react-redux";
import { Links } from "./Links.jsx";

const updateValue = (k, v) => s => ({ ...s, [k]: v })

const INITIAL_STATE = {
    fullname: "",
    email: "",
    password: "",
    telephone: "",
    company: ""
};

export const RegisterForm = () => {
    const [ userDetails, setUserDetails ] = useState(INITIAL_STATE);
    const [loading, setLoading ] = useState(false);
    const [error, setError ] = useState(null);

    const dispatch = useDispatch();

    const handleRegister = (ev) => {
        ev.preventDefault();
        if (
            userDetails.fullname == null || userDetails.fullname.length == 0 ||
            userDetails.email == null || userDetails.email.length == 0 ||
            userDetails.password == null || userDetails.password.length == 0
        ) {
            setError("Invalid form credentials");
        } else {
            setError(null);
            setLoading(true);
    
            dispatch(register(userDetails)).then(() => {
                setLoading(false);
                location.href="/#/";
            }, (e) => {
                setLoading(false);
                setError(e.toString());
            })
        }
    }

    let body = null;
    if(loading)
    {
        body = <div id="loading-display">
            <p><i className="fa fa-spinner fa-pulse fa-2x"></i></p>
            <h2>Signing in...</h2>
        </div>;
    }else{
        let bind = k => ({ value: userDetails[k], onChange: (ev) => setUserDetails(updateValue(k, ev.target.value )) })
        body = <div>
            {error ? <div className="alert alert-danger" role="alert"><p>{error}</p></div> : null}
            <div className="form-group">
                <label htmlFor="inputName">Full name</label>
                <input {...bind("fullname") } name="fullname" type="text" id="inputName" className="form-control input-lg" required />
            </div>
            <div className="form-group">
                <label htmlFor="inputEmail">Email address</label>
                <input {...bind("email") } name="email" type="email" id="inputEmail" className="form-control input-lg" required />
            </div>
            <div className="form-group">
                <label htmlFor="inputPassword">Password</label>
                <div className="form-group">
                    <input {...bind("password") } name="password" type="password" id="inputPassword" className="form-control input-lg" minLength={8} required />
                </div>
            </div>
            <hr />
            <div className="form-group">
                <label htmlFor="inputComp">Company</label> <small>(optional)</small>
                <input {...bind("company") } name="company" type="text" id="inputComp" className="form-control input-lg" />
            </div>
            <div className="form-group">
                <label htmlFor="inputTel">Telephone</label> <small>(optional)</small>
                <input {...bind("telephone") } name="telephone" type="tel" id="inputTel" className="form-control input-lg" />
            </div>
            <button className="btn btn-lg btn-primary btn-block" id="register" type="submit">Register</button>
            <a href="/#/" className="btn btn-lg btn-block" id="register">Cancel</a>
            <a href="/#/help">Help</a>
        </div>
    }

    return <form className="form-signin" id="register-form" onSubmit={handleRegister} >
        <img className="zeta-logo" src={logoUrl} />
        <h3 className="form-signin-heading">Register</h3>
        {body}
        <Links/>
    </form>
}
